import { render, staticRenderFns } from "./EventDetailV.vue?vue&type=template&id=ac07f40a&scoped=true"
import script from "./EventDetailV.vue?vue&type=script&lang=js"
export * from "./EventDetailV.vue?vue&type=script&lang=js"
import style0 from "./EventDetailV.vue?vue&type=style&index=0&id=ac07f40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac07f40a",
  null
  
)

export default component.exports